export const COLORS = {
  black: '#000000',
  white: '#F0F0F0',
  cyan: '#00FFFF',
  neon: {
    green: '#3bf58c',
    teal: '#00ffc3',
  },
  blues: {
    purple: '#888DBB',
    lighter: '#4BB2F9',
    light: '#84C9FB',
    midnight: '#272742',
  },
  greys: {
    dark: '#121212',
    medium: '#292926',
    light: '#e0dfdf',
    text: '#292926'
  },
  reds: {
    dark: '#963C20',
    light: '#B2330B',
  },
  red: '#963C20',
  teal: '#03DAC5',
  blue: '#3700B3',
  green: '#379B53',
  gold: '#CCAA33',
  error: 'CF6679',

  oranges: {
    dark: '#FAC81A',
    light: '#FFDF6D',
  },
  orange: '#FF9600',
  purple: '#BC8AFD',
  lime: '#B0EC9A',
  tan: '#EDC29A',
  pink: '#E31D69',
  aqua: '#1DDECB',

  darkgray: '#121212',
  background: '#F0EEE8',
  sand: '#D8D3C5',
  sand2: '#9D8B5E',

  // FUTURA
  creamsicle: '#E7AF7C',
  cream: '#E5E5E5',
  skyBlue: '#429FEA',
};

export const LOGO_GRADIENT = 'linear-gradient(90deg, #41F2EE 0%, #8E73FF 56.77%, #FB2CFF 100%)';
